// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'next/router';
import { openQuickViewWithValues } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { productTabListDataReq } from '@tcp/core/src/components/common/organisms/ProductTabList/container/ProductTabList.actions';
import {
  getIsDynamicBadgeEnabled,
  getIsTabbedCarouselRatingDisabled,
  getIsTabbedCarouselColorSwatchesEnabled,
  getIsNewSwatchURLEnabled,
  getIsTabbedCarouselATBDisabled,
  getIsTabbedCarouselDiscountPriceDisabled,
  getIsTabbedCarouselProductTileBorderDisabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import useDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import CarouselTabSaga from './CarouselTab.saga';
import CarouselTabReducer from './CarouselTab.reducer';

import { carouselTabDataReq } from './CarouselTab.actions';
import CarouselTab from '../views';

const mapStateToProps = (state, ownProps) => {
  const { ProductTabList, CarouselTab: carouselTabData } = state;
  const { icidParam = '' } = ownProps;
  return {
    icidParam,
    carouselTabData,
    productTabList: ProductTabList || {},
    isDynamicBadgeEnabled: getIsDynamicBadgeEnabled(state),
    isRatingViewDisabled: getIsTabbedCarouselRatingDisabled(state),
    isColorSwatchesEnabled: getIsTabbedCarouselColorSwatchesEnabled(state),
    isNewSwatchUrlEnabled: getIsNewSwatchURLEnabled(state),
    isTabbedATBDisabled: getIsTabbedCarouselATBDisabled(state),
    isDiscountPriceDisabled: getIsTabbedCarouselDiscountPriceDisabled(state),
    isTabbedProductTileBorderDisabled: getIsTabbedCarouselProductTileBorderDisabled(state),
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onQuickViewOpenClick: (payload) => {
      dispatch(openQuickViewWithValues(payload));
    },
    getProductTabListData: (payload) => {
      dispatch(productTabListDataReq(payload));
    },
    fetchRecommendationData: (payload) => {
      dispatch(carouselTabDataReq(payload));
    },
  };
};

const withReducer = withDynamicReducer({
  key: 'CarouselTab',
  reducer: CarouselTabReducer,
});
const withSaga = useDynamicSaga({ key: 'CarouselTabSaga', saga: CarouselTabSaga });
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default withRouter(compose(withReducer, withSaga, withConnect)(CarouselTab));
